import React from 'react';
import { createRoot } from 'react-dom/client';
import DevexHighOrderComponent from '../../src/components/react/devex_high_order_component/devex_high_order_component';
import DownloadableButton from '../../src/downloadable_details/components/downloadable_button/downloadable_button';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import '../../src/downloadable_details/styles/downloadable_details.global_styles.scss';
const queryClient = new QueryClient();

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('downloadable-details-react-app');

  if (container) {
    const root = createRoot(container);

    root.render(
      <DevexHighOrderComponent>
        <QueryClientProvider client={queryClient}>
          <DownloadableButton
            requiredPrivilegeConstantName={container.dataset.requiredPrivilegeConstantName || null}
            title={container.dataset.title}
            id={container.dataset.id}
          />
        </QueryClientProvider>
      </DevexHighOrderComponent>
    );
  }
});
